<template>
    <footer class="bg-light border-top py-3 ">
        <div class="container overflow-auto">
            <p class="float-none float-lg-left m-0 py-2 text-center text-lg-left"><span class="font-weight-bold">MySwitchPro</span> &copy; <span class="font-weight-light">All rights reserved</span></p>
            <div class="float-none float-lg-right m-0 d-flex flex-column flex-lg-row align-items-center">
                <ul class="list-group list-group-horizontal-sm text-center">
                    <li class="list-group-item border-0 p-2 bg-transparent "><router-link class="text-dark" :to="{ name: 'Help'}">FAQ</router-link></li>
<!--                    <li class="list-group-item border-0 p-2 bg-transparent "><router-link class="text-dark" :to="{ name: 'Contact'}">Contact</router-link></li>-->
                    <li class="list-group-item border-0 p-2 bg-transparent "><router-link class="text-dark" :to="{ name: 'Terms'}">Terms of use</router-link></li>
                    <li class="list-group-item border-0 p-2 bg-transparent "><router-link class="text-dark" :to="{ name: 'Privacy'}">Privacy</router-link></li>
                    <li class="list-group-item border-0 p-2 bg-transparent "><router-link class="text-dark" :to="{ name: 'Cookies'}">Cookie policy</router-link></li>
                </ul>
                <ul class="list-group list-group-horizontal social-links">
                    <li class="list-group-item border-0 p-2 bg-transparent ml-3 "><a class="text-dark" href="https://www.facebook.com/myswitchpro" target="_blank"><i class="fa fa-facebook"></i></a></li>
                    <li class="list-group-item border-0 p-2 bg-transparent ml-3 "><a class="text-dark" href="https://twitter.com/MySwitchPro" target="_blank"><i class="fa fa-twitter"></i></a></li>
                    <li class="list-group-item border-0 p-2 bg-transparent ml-3 "><a class="text-dark" href="https://www.instagram.com/myswitchpro/" target="_blank"><i class="fa fa-instagram"></i></a></li>
                </ul>
            </div>
        </div>
    </footer>
</template>
<script>
    export  default {

    }
</script>
<style scoped lang="scss">
    @import "../sass/base";
    footer {
        font-size: 14px;
        .social-links {
            font-size: 18px;
        }
    }

</style>
